import React, { useState, useEffect } from 'react';
import { oneOfType, array, object, string, func } from 'prop-types'
import { withRouter } from 'react-router-dom';;
import { withApollo } from 'react-apollo';
import { map, get, size, orderBy, filter, join, includes, isEmpty } from 'lodash';
import { Button, Divider, FlexContainer, Main, NotFound, Row, Column, Text, If, FormInput, Modal, Icon, Accordion } from '../../common';
import { withFirebase } from '../../../hoc';
import { MediaListener } from '../../utils';
import Filters from './Filters';
import Settings from './Settings';
import SPLIT_NOTIFY_SHUTDOWN from '../../../queries/SPLIT_NOTIFY_SHUTDOWN';
import { GET_SALES_CHANNELS, UPDATE_SALES_CHANNELS } from '../../../queries';

const Header = ({ storeName, search }) => {
    const [keyword, setKeyword] = useState('');

    const handleSearch = (value) => search(value);

    return (<>
        <FlexContainer pL={23} pR={23} pB={5}>
            <Row border='1px solid #eaeaea' borderRadius={3} padding='7px 13px' backgroundColor='white'>
                <Text text={storeName} strong size={15} color='#1FA02E' />
            </Row>
        </FlexContainer>
        <FlexContainer pL={23} pR={23} pB={10}>
            <Row border='1px solid #eaeaea' borderRadius={3} padding='3px 25px' backgroundColor='white' noWrap>
                <FormInput
                    placeholder='Ingrese palabra clave'
                    width='300px'
                    onChange={({ target }) => setKeyword(target.value)}
                />
                <Row noWrap align='center' justify='flex-end'>
                    <Button text='Limpiar' link onClick={() => handleSearch('')} width={150} />
                    <Button text='Buscar' action='action_name' onClick={() => handleSearch(keyword)} width={150} />
                </Row>
            </Row>
        </FlexContainer>
    </>);
};

Header.propTypes = {
    storeName: string,
    search: func
};

const SCSettings = ({ firebase, session, client }) => {
    const [globalStoreSettings, setGlobalStoreSettings] = useState({});
    const [initialGlobalStoreSettings, setInitialGlobalStoreSettings] = useState({});
    const [initialStoreSettings, setInitialStoreSettings] = useState({});
    const [salesChannel, setSalesChannel] = useState(null);
    const [storeSettings, setStoreSettings] = useState(null);
    const [companyGroup, setCompanyGroup] = useState(null);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabledButton, setDisabledButton] = useState(true);
    const [warningModalVisible, setWarningModalVisible] = useState(false);

    const getStoreSettings = (storeSettings) => {
        const settingsFiltered = filter(storeSettings, { description: 'Validación de peso' });

        return map(settingsFiltered, (setting) => {
            return {
                ...setting,
                settings: filter(get(setting, 'settings'), { key: 'weightsValidation' })
            };
        });
    }


    const addSettingsData = async (settingsDataConf) => {
        if (typeof settingsDataConf !== "object" || settingsDataConf === null) {
            return {}; 
        }
        try {
            
            const salesChannelId = get(salesChannel, 'data.comercial_policy', 0);
            const response = await client.query({
                query: GET_SALES_CHANNELS,
                variables: { filter: {where : `comercial_policy:${salesChannelId}`} },
                fetchPolicy: 'network-only'
            });
            const configBipicking =get(response, 'data.salesChannels[0]', {})

            const updatedSettingsData = {
                ...settingsDataConf,
                bipicking: get(configBipicking, 'bipicking', 0) == 1,
                bipicking_validation_max_items: get(configBipicking, 'bipicking_validation_max_items', 0),
                flag_lane: get(configBipicking, 'flag_lane', 0) == 1
            };

            setStoreSettings(updatedSettingsData)
            setInitialStoreSettings(updatedSettingsData)

        } catch (error) {
            console.log(error);
            setStoreSettings(settingsDataConf)
            setInitialStoreSettings(settingsDataConf)
        }
    };

    const saveSettingsData = async () => {
        try {
            if (!storeSettings) {
                return; 
            }

            const { bipicking, bipicking_validation_max_items, flag_lane } = storeSettings;
            
            await client.mutate({
                mutation: UPDATE_SALES_CHANNELS,
                variables: { 
                    input: {
                        comercial_policy: String(get(salesChannel, 'data.comercial_policy', 0)),
                        bipicking: bipicking ? 1 : 0,
                        bipicking_validation_max_items: bipicking_validation_max_items,
                        flag_lane: flag_lane ? 1 : 0
                    }
                }
            });
            
            
        } catch (error) {
            console.log(error);
        }
    };



    useEffect(() => {
        (async () => {
            await firebase.collection('config')
                .doc('backoffice')
                .onSnapshot(async (doc) => {
                    const storeSettings = get(doc.data(), 'store-settings', []);
                    const globalSettingsData = get(doc.data(), 'global-settings.groups-allowed-weights-validation');
                    const filterByGroupsAllowed = includes(get(session, 'groups'), globalSettingsData)

                    const storeSettingsFiltered = filterByGroupsAllowed
                        ? getStoreSettings(storeSettings)
                        : storeSettings;


                    setGlobalStoreSettings(storeSettingsFiltered);
                    setInitialGlobalStoreSettings(storeSettings);
                });

        })();
    }, []);

    useEffect(() => {
        (async () => {
            await firebase.collection('salesChannel')
                .doc(get(salesChannel, 'value.value', null))
                .onSnapshot(doc => {
                    addSettingsData(doc.data());
                });
        })();
    }, [salesChannel]);

    const modifySetting = (setting, value) => {
        if (setting === 'enableBaggingQR' && value === true) {
            const laneRoutingEnabled = get(storeSettings, 'enableLaneRouting', false);
            if (!laneRoutingEnabled) {
                setWarningModalVisible(true);
                return;
            }
        }
        setStoreSettings({ ...storeSettings, [setting]: value });
        setDisabledButton(false);
    };

    const updateSettingsOrder = async () => {
        try {
            await firebase.collection('config').doc('backoffice').update({
                'store-settings': globalStoreSettings
            });

            setVisible(true);
        } catch (error) {
            console.log(error);
        }
    };

    const saveChanges = async () => {
        setLoading(true);
        await saveSettingsData();
        await updateSettingsOrder();

        try {
            const oldSplit = get(initialStoreSettings, 'split');
            const newSplit = get(storeSettings, 'split');

            if (oldSplit && !newSplit) {
                await client.mutate({
                    mutation: SPLIT_NOTIFY_SHUTDOWN,
                    variables: {
                        salesChannelId: get(salesChannel, 'value.value', null)
                    }
                });
            }

            await firebase.collection('salesChannel').doc(get(salesChannel, 'value.value', null)).set(storeSettings);

            setVisible(true);
        } catch (error) {
            console.log(error);
        }
    };

    const closeModal = () => {
        setVisible(false);
        setLoading(false);
    };

    const onChangeSalesChannel = (value) => {
        setStoreSettings(null);
        setSalesChannel(value);
    };

    const search = (keyword) => {
        if (isEmpty(keyword)) return setGlobalStoreSettings(initialGlobalStoreSettings);

        const filtered = filter(globalStoreSettings, (param) => {
            const settings = map(get(param, 'settings'), 'value');
            const settingsString = join(settings, ' ');
            return includes(settingsString, keyword);
        });

        setGlobalStoreSettings(filtered);
    };

    return (
        <Main background='f4f4f4' withFooter>
            <MediaListener values={['16.7%', '100%', '100%']}>
                {({ currentValue }) => {
                    const fullWidth = currentValue === '100%';
                    const storeSettingsFormatted = map(storeSettings, (value, key) => ({ key, value }));
                    return (
                        <>
                            <Filters
                                currentValue={currentValue}
                                onChangeSalesChannels={onChangeSalesChannel}
                                onChangeSelectedCompanyGroup={({ value }) => setCompanyGroup(value)}
                                selectedCompanyGroup={companyGroup}
                            />
                            <If condition={salesChannel}
                                then={
                                    <If condition={size(storeSettingsFormatted) > 0}
                                        then={<>
                                            <Header storeName={get(salesChannel, 'data.name')} search={search} />
                                            <FlexContainer direction='column' pL={23} pR={23} pB={23}>
                                                {map(orderBy(globalStoreSettings, 'order', ['asc']), ({ description, settings, order: orderCategory }, index) => (
                                                    <Accordion
                                                        key={index}
                                                        iconOpened='chebron_down'
                                                        iconClosed='chebron_up'
                                                        iconSize={9}
                                                        title={<Text text={description} strong />}
                                                        styleHeader={{ borderRadius: 8 }}
                                                        style={{ borderRadius: 8, marginBottom: 5, boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.08)', padding: 3 }}
                                                    >
                                                        <Divider style={{ padding: 0, margin: 0 }} />
                                                        <Column mB={15}>
                                                            <Settings
                                                                orderCategory={orderCategory}
                                                                globalSettingsCurrent={settings}
                                                                globalStoreSettings={globalStoreSettings}
                                                                setGlobalStoreSettings={setGlobalStoreSettings}
                                                                modifySetting={modifySetting}
                                                                storeSettings={storeSettingsFormatted}
                                                                setDisabledButton={setDisabledButton}
                                                            />
                                                        </Column>
                                                    </Accordion>
                                                ))}
                                                <Row justify='flex-end'>
                                                    <Button
                                                        top={5}
                                                        loading={loading}
                                                        text='Guardar'
                                                        width={!fullWidth && 300}
                                                        onClick={saveChanges}
                                                        disabled={disabledButton}
                                                    />
                                                </Row>
                                            </FlexContainer>
                                        </>}
                                        else={
                                            <NotFound
                                                firstTextLine='Esta sala no tiene opciones para modificar.'
                                                iconBackgroundColor='#F4F4F4'
                                                backgroundColor='#F4F4F4'
                                                iconColor='#c0c0c0'
                                                iconSize={85}
                                                fontSize={20}
                                            />
                                        }
                                    />
                                }
                                else={
                                    <NotFound
                                        firstTextLine='Aún no se ha realizado una búsqueda, utiliza los filtros.'
                                        icon='find'
                                        iconBackgroundColor='#F4F4F4'
                                        backgroundColor='#F4F4F4'
                                        iconColor='#c0c0c0'
                                        iconSize={85}
                                        fontSize={20}
                                    />
                                }
                            />
                        </>
                    );
                }}
            </MediaListener>
            <Modal visible={visible} withoutHeader>
                <FlexContainer align='center' direction='column'>
                    <Icon name='check-mark' size={90} color='#1fa02e' top={20} bottom={20} />
                    <Text
                        size={14}
                        strong
                        text='Se ha realizado la actualización correctamente'
                        align='center'
                    />
                    <Button text='Cerrar' margin={30} fitContent onClick={closeModal} />
                </FlexContainer>
            </Modal>
            <Modal visible={warningModalVisible} withoutHeader>
                <FlexContainer align='center' direction='column'>
                    <Icon name='alert-circle' size={90} color='#EB963C' top={20} bottom={20} />
                    <Text
                        size={15}
                        strong
                        text='No se puede activar QR embolsado'
                        align='center'
                    />
                    <Text
                        size={13}
                        text='Para activar QR embolsado, primero debes tener Carriles encendido.'
                        align='center'
                        top={8}
                    />
                    <Button text='Entendido' margin={30} fitContent onClick={() => setWarningModalVisible(false)} />
                </FlexContainer>
            </Modal>
        </Main>
    );
};

SCSettings.propTypes = {
    firebase: oneOfType([array, object]),
    session: object,
    client: object
};

export default withApollo(withFirebase(withRouter(SCSettings)));
